import styled from 'styled-components';
import { margin, padding, pxToRem } from '../../styles/mixins';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0,0,0, .5);
`
export const ContentWrapper = styled.div`
  max-width: 640px;
  width: 100%;
  min-height: 460px;
  background-color: var(--white);
  border-radius: 8px;
  ${padding(60, 55)};

  @media screen and (max-width: 767px) {
    max-width: 90%;
  }
`
export const TextTop = styled.h3`
  ${pxToRem(16)};
  font-weight: 700;
  color: var(--ins-blue);
  margin-bottom: 16px;
`
export const TextTitle = styled.h2`
  ${pxToRem(32)};
  font-weight: 400;
  color: var(--gray-900);
  margin-bottom: 16px;
  white-space: pre-wrap;
`

export const Paragraph = styled.p`
  color: var(--gray-500);
  ${pxToRem(16)};
  ${margin(0, 0, 16, 0)};
`
export const TextSugestions = styled.p`
  ${pxToRem(16)};
  ${margin(34, 0, 20, 0)};
  font-weight: 400;
  color: var(--gray-900);
`

export const TextSubtitle = styled.p`
  ${pxToRem(20)};
  font-weight: 400;
  color: var(--gray-900);
  ${margin(0, 0, 32)};
`
export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;

  input {
    border: none;
    border-bottom: 1px solid var(--gray-900);
    height: 32px;

    &:focus {
      outline: none;
    }
  }
`
export const ListErrors = styled.ul`
  list-style: disc;
  ${padding(0, 0, 0, 20)};
  ${margin(0, 0, 50, 0)};

  li {
    margin-bottom: 10px;
  }
`
export const ButtonWrapper = styled.div`
  ${margin(72, 0, 0)};
  display: flex;
  align-items: center;
`
export const ButtonBack = styled.button`
  width: 93px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 1px solid var(--ins-blue);
  background-color: var(--white);
  color: var(--ins-blue);
  ${pxToRem(16)};
  font-weight: 700;
  margin-right: 23px;
`
export const ButtonPurchase = styled.button`
  width: 205px;
  height: 42px;
  border: none;
  border-radius: 8px;
  background-color: var(--ins-blue);
  ${pxToRem(16)};
  font-weight: 700;
  color: var(--white);
`
export const Image = styled.img`
  width: 16px;
  height: 16px;
  ${margin(0, 5, 0, 0)};
`